module.exports = __webpack_public_path__ + "media/images/common/top_img-eea944efdfdd9855f2a57ef15ece8089.jpg";